import React from 'react';
import './FancyInput.css';

const FancyInput = props => {
	return <input type="text" className="FancyInput" {...props} />;
};

export default FancyInput;



// WEBPACK FOOTER //
// ./src/widgets/FancyInput.js